import React from "react";
import { useTheme } from "../hooks/useTheme";
import { useBranding } from "../hooks/useBranding";
import { useParams } from "react-router-dom";

interface DynamicLogoProps {
  className?: string;
  alt?: string;
  fallbackSrc?: string;
  onClick?: () => void;
  style?: React.CSSProperties;
  /** Catalog id for branding (e.g. from URL ?id=). Overrides useParams when set (e.g. on login page). */
  catalogId?: string;
}

const DynamicLogo: React.FC<DynamicLogoProps> = ({ className = "w-[200px]", alt = "Brand Logo", fallbackSrc = "./brand-logo.svg", onClick, style, catalogId }) => {
  const { branding, loading } = useTheme();
  const { id: paramId } = useParams();
  const id = catalogId ?? paramId;

  // Fetch branding if we have an id (for public routes like login)
  useBranding(id);

  if (loading) {
    return <div className={`${className} bg-gray-200 animate-pulse rounded`} />;
  }

  const logoSrc = branding?.logo_url || fallbackSrc;

  return (
    <img
      src={logoSrc}
      alt={alt}
      className={className}
      style={style}
      onClick={onClick}
      onError={(e) => {
        // Fallback to default logo if dynamic logo fails to load
        if (e.currentTarget.src !== fallbackSrc) {
          e.currentTarget.src = fallbackSrc;
        }
      }}
    />
  );
};

export default DynamicLogo;
